import React from 'react';
import ErpDocPage from '../components/ErpDocPage';

const CustomerInvoices = () => {
  return <ErpDocPage moduleKey="customer_invoices" />;
};

export default CustomerInvoices;